<script>
export default {
	props: {
		data: Object,
		index: Number,
	},
	metaInfo() {
		const cssText = this.data.cssText
		if (!cssText) return {}
		return {
			style: [
				{
					vmid: 'dpc-css-styles-' + this.index,
					cssText,
					type: 'text/css',
				},
			],
		}
	},
	render() {
		return null // Only metaInfo
	},
}
</script>

